export const ATTRIBUTES_VISIBILITY = {
  visible: [] as string[],
  hidden: [] as string[],
}
export const OPEN_TEXT_FIELD: string | null = null
